import { useMemo, useRef } from 'react';
import { IBreadcrumbs } from '../../molecules/Breadcrumbs';
import useImpressionPackageService from '../../../hooks/emarsys/package-service/useImpressionPackageService';

interface ServicesDetailTableProps {
  servicePlan: {
    firstPeriodicServiceTitle: { name: string; value: string[] }[];
    firstPeriodicServiceDetail: { name: string; value: string[] }[];
  };
  viewPackageCarModal: boolean;
  impressionData?: {
    pageTitle: string;
    breadcrumbItems: IBreadcrumbs[];
  };
  feature?: string;
}

const ServicesDetailTable = ({
  servicePlan,
  viewPackageCarModal,
  impressionData = { pageTitle: '', breadcrumbItems: [] },
  feature = '',
}: ServicesDetailTableProps) => {
  const impressionRef = useRef(null);

  const tableHeader = useMemo(() => {
    const titles =
      servicePlan?.firstPeriodicServiceTitle?.find((item) => item?.name === 'Kategori')['value'] ||
      [];
    const subTitles =
      servicePlan?.firstPeriodicServiceTitle?.find((item) => item?.name === 'Deskripsi')['value'] ||
      [];

    return titles.map((title, index) => ({
      title,
      subTitle: subTitles[index] ? subTitles[index] : null,
    }));
  }, [servicePlan]);

  const tableBody = useMemo(() => {
    return servicePlan?.firstPeriodicServiceDetail.map((item) => {
      const value = item.value.map((val) => {
        switch (val) {
          case 'BLANK':
            return 'Tidak';
          case 'DOT':
            return 'Ya';
          case 'FREE':
            return 'Gratis';
          default:
            return val;
        }
      });

      return {
        name: item.name,
        value,
      };
    });
  }, [servicePlan]);

  if (feature === 'PACKAGE_SERVICE') {
    useImpressionPackageService(
      impressionRef,
      impressionData.pageTitle,
      impressionData.breadcrumbItems,
      'spesifikasi paket servis'
    );
  }
  return (
    <div
      className={`my-6 w-full ${viewPackageCarModal ? 'fixed inset-x-0 z-50 pr-4' : ''}`}
      ref={impressionRef}
    >
      <div className="w-0 min-w-full overflow-x-auto rounded">
        <table className="w-max md:w-full border-collapse">
          <thead>
            <tr>
              <th className="sticky left-0 z-20 px-3 py-2 w-32 min-w-[128px] text-xs text-start font-semibold uppercase bg-reliableBlack10 text-reliableBlack lg:text-base lg:align-top">
                Kategori
              </th>

              {tableHeader.map((header) => (
                <th
                  key={header.title}
                  className="px-3 py-2 w-44 min-w-[176px] text-xs text-start font-semibold bg-reliableBlack3 text-reliableBlack lg:text-base lg:align-top"
                >
                  <span className="block uppercase">{header.title}</span>
                  {header.subTitle && (
                    <span className="block text-xs lg:text-[10px] font-normal first-letter:uppercase mt-0.5">
                      {header.subTitle}
                    </span>
                  )}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {tableBody &&
              tableBody.map((item) => (
                <tr key={item.name}>
                  <td className="sticky left-0 z-10 px-3 py-2 text-xs font-medium bg-reliableBlack10 text-reliableBlack lg:font-normal">
                    {item.name}
                  </td>

                  {item.value.map((val, index) => (
                    <td
                      key={index}
                      className="px-3 py-2 text-xs font-normal bg-reliableBlack3 text-reliableBlack"
                    >
                      {val}
                    </td>
                  ))}
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ServicesDetailTable;
